(function () {
  var form = document.getElementById('dw-wholesale-form');
  if (!form) return;

  var submitBtn = document.getElementById('ws-submit');
  var btnLabel  = submitBtn.querySelector('.ws-btn-label');
  var btnSpinner = submitBtn.querySelector('.ws-btn-spinner');
  var errorBox  = document.getElementById('ws-error');
  var successBox = document.getElementById('ws-success');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    handleSubmit();
  });

  async function handleSubmit() {
    clearError();

    var data = collectData();

    var missing = ['firstName','lastName','email'].find(function (k) {
      return !data[k] || !data[k].trim();
    });
    if (missing) {
      showError('Please fill in all required fields.');
      var el = form.querySelector('[name="' + missing + '"]');
      if (el) el.focus();
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      showError('Please enter a valid email address.');
      document.getElementById('ws-email').focus();
      return;
    }

    var workerUrl = form.dataset.workerUrl;
    if (!workerUrl) {
      showError('Signup is temporarily unavailable. Please call us at (717) 879-9565.');
      return;
    }

    setLoading(true);

    try {
      var res = await fetch(workerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      var json;
      try { json = await res.json(); } catch (_) { json = {}; }

      if (res.ok && json.success) {
        showSuccess(json.status);
      } else {
        showError(json.error || 'Something went wrong. Please try again or call us at (717) 879-9565.');
      }
    } catch (_) {
      showError('Could not connect. Please check your connection or call us at (717) 879-9565.');
    } finally {
      setLoading(false);
    }
  }

  function showSuccess(status) {
    // Existing account upgraded (or already wholesale): swap in the copy for
    // that path — "check your email to activate" would be wrong or confusing.
    if (status && status !== 'created') {
      var altTitle = successBox.dataset.altTitle;
      var altMessage = successBox.dataset.altMessage;
      var titleEl = successBox.querySelector('[data-success-title]');
      var messageEl = successBox.querySelector('[data-success-message]');
      if (altTitle && titleEl) titleEl.textContent = altTitle;
      if (altMessage && messageEl) messageEl.textContent = altMessage;
    }

    // Signed-in customer just got the tag: their pages rendered before it
    // existed, so the theme-wide auto-apply hasn't run. Drop the discount
    // cookie now — their very next checkout already carries the code.
    if (form.dataset.loggedIn === 'true' && form.dataset.discountCode) {
      fetch('/discount/' + encodeURIComponent(form.dataset.discountCode), {
        credentials: 'same-origin',
        redirect: 'manual',
      }).catch(function () { /* the cart banner still shows the code */ });
    }

    form.hidden = true;
    successBox.hidden = false;
    successBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function collectData() {
    var fd = new FormData(form);
    var out = {};
    fd.forEach(function (v, k) { out[k] = v; });
    return out;
  }

  function setLoading(on) {
    submitBtn.disabled = on;
    btnLabel.hidden = on;
    btnSpinner.hidden = !on;
  }

  function showError(msg) {
    errorBox.textContent = msg;
    errorBox.hidden = false;
    errorBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearError() {
    errorBox.textContent = '';
    errorBox.hidden = true;
  }
})();
